<template>
  <div class="userMain">
    <!-- 搜索框 -->
    <SearchBar @search="fetchData" />

    <!-- 表单 -->
    <el-table
      class="table"
      v-loading="listLoading"
      height="750"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>

      <el-table-column label="用户名" align="center">
        <template slot-scope="scope">
          {{ handledecrypt(scope.row.user.nickName) }}
        </template>
      </el-table-column>

      <el-table-column label="用户电话" align="center">
        <template slot-scope="scope">
          {{
            handledecrypt(scope.row.user.mobile, scope.row.user.isShowAllPhone)
          }}
        </template>
      </el-table-column>

      <el-table-column label="用户留言" align="center">
        <template slot-scope="scope">
          {{ scope.row.message }}
        </template>
      </el-table-column>

      <!-- <el-table-column class-name="status-col" label="更新时间" align="center">
        <template slot-scope="scope">
          <div >{{ scope.row.sendTime }}</div>
        </template>
    </el-table-column> -->

      <!-- 
    <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <div class="lastBtn">  <el-button size="small" @click="editCell(scope.row)" type="text">编辑标题</el-button></div>
        </template>
    </el-table-column> -->
    </el-table>

    <!-- 分页 -->
    <Pagination ref="Pagination" />
  </div>
</template>
<script>
import { getFeedBackApi } from '@/api/user.js';
import SearchBar from './components/searchBar';
import Pagination from '@/components/Pagination'; // 分页
import { mapGetters } from 'vuex';
import { decrypt } from '@/utils/encryp';

export default {
  name: 'FeebBack',
  components: {
    SearchBar,
    Pagination,
  },
  data() {
    return {
      list: [],
      listLoading: false,
      editShow: true,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      totalCount: '',
      statuList: ['编辑中', '已发布', '已删除'],
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(['paginObj']),
  },

  watch: {
    // 当分页组件中页码或页容量发生改变时会重新发请求渲染页面
    paginObj: 'fetchData',
  },

  methods: {
    // 处理解密
    handledecrypt(str, isShowAllPhone = true) {
      // if (!str || str.indexOf('=') == -1) return str;
      let showStr = decrypt(str);
      return isShowAllPhone
        ? showStr
        : showStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData(userId = '') {
      try {
        this.listLoading = true;
        // status ->  1.编辑中， 2.已发布， 3.已删除
        let res = await getFeedBackApi({
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          userId,
        });
        if (res.code !== 200) return;
        this.listLoading = false;
        let { pageSize, pageIndex, dataList, totalCount } = res.data;
        this.list = dataList;
        this.pageSize = pageSize;
        this.pageIndex = pageIndex;
        this.totalCount = totalCount;
        this.$refs.Pagination.pageSize = pageSize;
        this.$refs.Pagination.pageIndex = pageIndex;
        this.$refs.Pagination.totalCount = totalCount;
      } catch (e) {
        window.console.log(e);
      }
    },

    editCell(row) {
      window.console.log(row);
    },
  },
};
</script>

<style lang="less" scoped>
.userMain {
  position: relative;
}

.table {
  height: 75vh;
  overflow: auto;
  // white-space: nowrap;
  // overflow-x: scroll;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.lastBtn {
  margin-top: 10px;
}
</style>
